import { useLocalization } from '@ais-ui/locale-management';
import { ChangePassword } from './ChangePassword';

export function SettingsChangePasswordPage() {
  const { messages } = useLocalization();

  return (
    <div className="space-y-6 w-full">
      <ChangePassword authenticated={true} />
    </div>
  );
}
